// https://stackoverflow.com/a/44198641/12161614
export function isValidDate(date) {
  return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date)
}